import apiClient from './apiClient';

export const toggleBookmark = async ({ userId, novelId }) => {
  if (!userId || !novelId) {
    throw new Error('Both userId and novelId are required to toggle a bookmark.');
  }

  const response = await apiClient.post('/api/bookmarks/toggle', { userId, novelId });
  return response.data;
};

export const getBookmarkStatus = async ({ userId, novelId }) => {
  if (!userId || !novelId) {
    throw new Error('Both userId and novelId are required to check bookmark status.');
  }

  const response = await apiClient.get('/api/bookmarks/status', {
    params: { userId, novelId },
  });
  return response.data;
};

export const getUserBookmarks = async (userId) => {
  if (!userId) {
    throw new Error('userId is required to fetch user bookmarks.');
  }

  const response = await apiClient.get(`/api/bookmarks/user/${userId}`);
  return response.data;
};

